import { useRef, useState } from 'react'
import { api } from '@/api/client'
import { Button } from './primitives'

/** Incarcarea unei imagini de identitate (sigla, semnatura, stampila). Previzualizarea se
 *  cere cu un parametru de versiune, altfel browserul arata in continuare fisierul vechi
 *  dupa inlocuire — adresa ramanand aceeasi. */
export function IncarcaImagine({
  eticheta, sursa, cale, camp, campuri, gata, indiciu,
}: {
  eticheta: string
  /** Adresa de previzualizare, sau null cand nu exista inca fisier. */
  sursa: string | null
  cale: string
  camp: string
  campuri?: Record<string, string>
  gata: () => void
  indiciu?: string
}) {
  const alege = useRef<HTMLInputElement>(null)
  const [stare, setStare] = useState<string | null>(null)
  const [lucreaza, setLucreaza] = useState(false)
  const [versiune, setVersiune] = useState(0)

  const trimite = async () => {
    const f = alege.current?.files?.[0]
    if (!f) { setStare('Alege intai un fisier'); return }
    setLucreaza(true); setStare(null)
    try {
      await api.incarca(cale, f, camp, campuri)
      setVersiune((v) => v + 1)
      setStare('Incarcat')
      if (alege.current) alege.current.value = ''
      gata()
    } catch (e) {
      setStare(e instanceof Error ? e.message : 'Nu s-a putut incarca')
    } finally {
      setLucreaza(false)
    }
  }

  return (
    <div>
      <p className="text-[12.5px] text-muted mb-1.5">{eticheta}</p>
      {sursa && (
        <img src={`${sursa}${sursa.includes('?') ? '&' : '?'}v=${versiune}`} alt={eticheta}
          className="h-16 mb-2 object-contain bg-page rounded p-1.5" />
      )}
      <div className="flex flex-wrap items-center gap-2.5">
        <input ref={alege} type="file" accept="image/png,image/jpeg,image/gif,image/svg+xml"
          className="text-[13px]" />
        <Button variant="quiet" onClick={trimite} disabled={lucreaza}>
          {lucreaza ? 'Se incarca…' : 'Incarca'}
        </Button>
        {stare && <span className="text-[12.5px] text-muted">{stare}</span>}
      </div>
      {indiciu && <p className="mt-1 text-[12px] text-muted">{indiciu}</p>}
    </div>
  )
}
